<template>
	<div class="product-property-list">
		<p v-if="type == 'test'" class="title" v-translate>Tests</p>
		<p v-else class="title" v-translate>Manipulations</p>
		<v-btn small fab class="mb-3" color="primary" @click="showNewItemForm = !showNewItemForm">
			<v-icon>mdi-plus</v-icon>
		</v-btn>
		<template v-if="showNewItemForm">
			<v-form ref="newItemForm" v-model="validItem">
				<v-row no-gutters>
					<v-col cols="12" sm="6">
						<v-text-field
							v-model="newItemNamePT"
							:label="$gettext('Name') + ' PT'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
						<v-text-field
							v-model="newItemNameEN"
							:label="$gettext('Name') + ' EN'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
						<v-text-field
							v-model="newItemNameES"
							:label="$gettext('Name') + ' ES'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="6">
						<v-text-field
							v-model="newItemShortNamePT"
							:label="$gettext('Short Name') + ' PT'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
						<v-text-field
							v-model="newItemShortNameEN"
							:label="$gettext('Short Name') + ' EN'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
						<v-text-field
							v-model="newItemShortNameES"
							:label="$gettext('Short Name') + ' ES'"
							outlined
							class="px-2"
							:rules="[required]"
						></v-text-field>
					</v-col>
				</v-row>
			</v-form>
			<v-row no-gutters>
				<v-btn color="primary" class="mb-2" @click="addItem">
					<translate>Add</translate>
				</v-btn>
			</v-row>
		</template>
		<p v-if="items.length == 0" class="font-weight-thin ml-2" v-translate>No items.</p>
		<v-list v-else flat>
			<v-list-item
				v-for="item in items"
				:key="item.id"
				style="border: 1px solid #e0e0e0; border-radius: 5px"
				color="primary"
			>
				<v-list-item-icon class="mr-3">
					<v-icon color="primary">mdi-circle-small</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>{{item.name_pt}}</v-list-item-title>
					<v-list-item-subtitle>{{item.short_name_pt}}</v-list-item-subtitle>
					<v-list-item-action-text v-if="type == 'test'">
						<v-row no-gutters align="center">
							<span class="my-1" v-translate>Recomended Manipulations</span>
							<v-btn
								x-small
								icon
								color="primary"
								@click="itemEdited = item; showItemRecommendations = true"
							>
								<v-icon small>mdi-plus-circle</v-icon>
							</v-btn>
						</v-row>
						<v-row no-gutters>
							<span
								v-if="item.recommended_manipulations.length == 0"
								class="font-weight-thin ml-2"
								v-translate
							>No recommendations.</span>
							<v-chip
								v-else
								v-for="rec in item.recommended_manipulations"
								:key="rec.id"
								small
								text-color="gray"
								class="px-2"
							>
								<span>{{rec.short_name_pt}}</span>
							</v-chip>
						</v-row>
					</v-list-item-action-text>
				</v-list-item-content>
				<v-list-item-action class="primary--text">
					<v-row no-gutters align="center">
						<v-btn class="ml-3" icon @click="itemEdited = item; showEditItem = true">
							<v-icon color="primary">mdi-pencil</v-icon>
						</v-btn>
						<v-btn class="ml-1" icon @click="itemToDelete = item; showDeleteItem = true">
							<v-icon color="primary">mdi-delete</v-icon>
						</v-btn>
					</v-row>
				</v-list-item-action>
			</v-list-item>
		</v-list>
		<v-dialog v-model="showEditItem" max-width="60%">
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Edit</translate>
				</v-card-title>
				<v-card-text class="pt-2">
					<v-form ref="editItemForm" v-model="validItem">
						<v-row no-gutters>
							<v-col cols="12" sm="6">
								<v-text-field
									v-model="itemEdited.name_pt"
									:label="$gettext('Name') + ' PT'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
								<v-text-field
									v-model="itemEdited.name_en"
									:label="$gettext('Name') + ' EN'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
								<v-text-field
									v-model="itemEdited.name_es"
									:label="$gettext('Name') + ' ES'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="6">
								<v-text-field
									v-model="itemEdited.short_name_pt"
									:label="$gettext('Short Name') + ' PT'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
								<v-text-field
									v-model="itemEdited.short_name_en"
									:label="$gettext('Short Name') + ' EN'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
								<v-text-field
									v-model="itemEdited.short_name_es"
									:label="$gettext('Short Name') + ' ES'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary darken-1" text @click="showEditItem = false">
						<translate key="close">Close</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="editItem(itemEdited)">
						<translate key="save">Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="showError" max-width="40%">
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Error</translate>
				</v-card-title>
				<v-card-text class="pt-2">Não foi possível remover o item</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showError = false">
						<translate key="close">Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="showItemRecommendations" max-width="60%">
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Recommendations</translate>
				</v-card-title>
				<v-card-text class="pt-2">
					<v-row no-gutters>
						<v-autocomplete
							v-model="itemEdited.recommended_manipulations_ids"
							:items="manipulations"
							filled
							chips
							color="blue-grey lighten-2"
							label="Manipulations"
							item-text="name_pt"
							item-value="id"
							multiple
						>
							<template v-slot:selection="data">
								<v-chip
									v-bind="data.attrs"
									:input-value="data.selected"
									close
									@click="data.select"
									@click:close="removeRecommendation(data.item)"
								>{{ data.item.short_name_pt }}</v-chip>
							</template>
							<template v-slot:item="data">
								<v-list-item-content>
									<v-list-item-title v-html="data.item.name_pt"></v-list-item-title>
									<v-list-item-subtitle v-html="data.item.short_name_pt"></v-list-item-subtitle>
								</v-list-item-content>
							</template>
						</v-autocomplete>
					</v-row>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary darken-1" text @click="showItemRecommendations = false">
						<translate key="close">Cancel</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="saveRecommendations">
						<translate key="close">Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<DeleteConfirmationDialog
			v-model="showDeleteItem"
			:item="type"
			@delete="deleteItem(itemToDelete)"
		/>
	</div>
</template>

<script>
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";

export default {
	name: "JointTest",
	props: ["type", "items", "jointId", "manipulations"],
	components: {
		DeleteConfirmationDialog
	},
	data: () => ({
		showNewItemForm: false,
		newItemNamePT: "",
		newItemNameEN: "",
		newItemNameES: "",
		newItemShortNamePT: "",
		newItemShortNameEN: "",
		newItemShortNameES: "",
		showEditItem: false,
		validItem: false,
		itemEdited: { recommended_manipulations: [] },
		showDeleteItem: false,
		itemToDelete: {},
		showError: false,
		showItemRecommendations: false
	}),
	computed: {
		required() {
			return value => !!value || this.$gettext("Required.");
		}
	},
	methods: {
		addItem() {
			if (this.$refs.newItemForm.validate()) {
				const form = new FormData();
				form.append("name_pt", this.newItemNamePT);
				form.append("name_en", this.newItemNameEN);
				form.append("name_es", this.newItemNameES);
				form.append("short_name_pt", this.newItemShortNamePT);
				form.append("short_name_en", this.newItemShortNameEN);
				form.append("short_name_es", this.newItemShortNameES);
				axios
					.post(
						"/osteopathy/joint/" + this.jointId + "/" + this.type + "/new",
						form
					)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
							this.items.unshift(response.data.item);
							this.newItemNamePT = "";
							this.newItemNameEN = "";
							this.newItemNameES = "";
							this.showNewItemForm = false;
						}
					})
					.catch(error => console.log(error));
			}
		},
		editItem(item) {
			if (this.$refs.editItemForm.validate()) {
				const form = new FormData();
				form.append("name_pt", item.name_pt);
				form.append("name_en", item.name_en);
				form.append("name_es", item.name_es);
				form.append("short_name_pt", item.short_name_pt);
				form.append("short_name_en", item.short_name_en);
				form.append("short_name_es", item.short_name_es);
				axios
					.post("/osteopathy/" + this.type + "/" + item.id + "/edit", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") this.showEditItem = false;
					})
					.catch(error => console.log(error));
			}
		},
		deleteItem(item) {
			axios
				.post("/osteopathy/" + this.type + "/" + item.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted") {
						this.items.splice(this.items.indexOf(item), 1);
						this.showDeleteItem = false;
					} else {
						this.showDeleteItem = false;
						this.showError = true;
					}
				})
				.catch(error => console.log(error));
		},
		removeRecommendation(item) {
			const index = this.itemEdited.recommended_manipulations_ids.indexOf(
				item.id
			);
			if (index >= 0)
				this.itemEdited.recommended_manipulations_ids.splice(index, 1);
		},
		saveRecommendations() {
			axios
				.post("/osteopathy/" + this.type + "/" + this.itemEdited.id + "/recommendations", {ids: this.itemEdited.recommended_manipulations_ids})
				.then(response => {
					console.log(response.data);
					this.itemEdited.recommended_manipulations = response.data.test.recommended_manipulations;
					this.itemEdited.recommended_manipulations_ids = response.data.test.recommended_manipulations_ids;
					this.showItemRecommendations = false;
				})
				.catch(error => console.log(error));
		}
	}
};
</script>